import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';
import { MemberPurchase } from './models/member-purchase.model';

export interface PurchaseState extends EntityState<MemberPurchase> {}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'purchase', idKey: 'LogId', cache: { ttl: 30000 } })
export class PurchaseStore extends EntityStore<PurchaseState> {
  constructor() {
    super();
  }
}
